import { authenticateRequest } from '@api/authenticateRequest';

import type { operations } from '@type/model';
import type { OmitGroupIdInHeader } from '@type/util';

type DeleteFamilyEventPath =
  operations['AdminEventController_deleteAlreadyActionEvent']['parameters']['path'];
type DeleteFamilyEventHeaders =
  operations['AdminEventController_deleteAlreadyActionEvent']['parameters']['header'];

interface DeleteFamilyEventProps {
  path: DeleteFamilyEventPath;
  headers?: OmitGroupIdInHeader<DeleteFamilyEventHeaders>;
}

type DeleteFamilyEventResponse = number;

export async function deleteFamilyEvent({
  path,
  headers,
}: DeleteFamilyEventProps): Promise<DeleteFamilyEventResponse | false> {
  const response = await authenticateRequest<DeleteFamilyEventResponse>({
    method: 'delete',
    url: `/api/v1/admin/events/${path.eventId}`,
    headers,
  });

  console.log('deleteFamilyEvent', { response });
  return response;
}
